import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { SelectOption } from '../../model/select.option';

interface StatusEntry {
  kind: 'none' | 'status';
  option?: SelectOption;
}

/**
 * `app-status-menu` — CONTEÚDO BURRO do menu de status (análogo ao app-group-menu),
 * projetado num `app-popover`. Sem Material/CDK. Renderiza os chips de status (cor cheia
 * + ícone Material Symbols, via os mixins GLOBAIS de _status-chip.scss) e emite `select`;
 * a persistência/diálogos ficam no controlador (app-status-select).
 *
 * A11y: role="listbox" + roving por aria-activedescendant; ↑/↓/Home/End, Enter/Espaço.
 */
@Component({
  selector: 'app-status-menu',
  templateUrl: './status-menu.component.html',
  styleUrls: ['./status-menu.component.scss'],
})
export class StatusMenuComponent implements OnChanges {
  @Input() options: SelectOption[] = [];
  @Input() selectedId: any = null;
  @Input() indices = { internal: 'id', public: 'value' };
  @Input() prependPublic = '';
  @Input() includeNoneOption = false;
  /** Mapa por status: { [valor]: { fontSet, fontIcon, color } }. */
  @Input() icons: { [key: string]: { fontSet: string; fontIcon: string; color: string } } = {};

  // eslint-disable-next-line @angular-eslint/no-output-native -- `select` é a semântica do menu (status escolhido), não evento DOM nativo
  @Output() select = new EventEmitter<any>();

  entries: StatusEntry[] = [];

  ngOnChanges(): void {
    this.entries = this.buildEntries();
  }

  private buildEntries(): StatusEntry[] {
    const list: StatusEntry[] = [];
    if (this.includeNoneOption) { list.push({ kind: 'none' }); }
    (this.options || []).forEach(option => list.push({ kind: 'status', option }));
    return list;
  }

  /** Classe de status (lowercase) que casa com submission-chip-colors (&.active/.accepted/…). */
  statusClass(option: SelectOption): string {
    return (option[this.indices.public] || '').toString().toLowerCase();
  }

  iconFor(option: SelectOption): { fontSet: string; fontIcon: string; color: string } | undefined {
    return this.icons[option[this.indices.public]];
  }

  isSelected(entry: StatusEntry): boolean {
    if (entry.kind === 'none') { return this.selectedId == null; }
    return entry.option[this.indices.internal] === this.selectedId;
  }

  activate(entry: StatusEntry): void {
    this.select.emit(entry.kind === 'none' ? null : entry.option[this.indices.internal]);
  }
}
